import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import _isEmpty from "lodash/isEmpty";
import _partition from "lodash/partition";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { ChartTile, PageHeader } from "components/PageHeader";
import OrdersList from "./List/OrdersList";
import useStylesGlobal from "styles/globalStyles";

const Orders = ({ device_id, orders, onRefresh, onDone }) => {
  const global = useStylesGlobal();
  const [count, setCount] = useState(0);
  const [chart, setChart] = useState();

  useEffect(() => {
    if (orders) {
      let count = 0;
      for (const line_items of orders
        .filter((x) => !x.completed_at)
        .filter((x) => !_isEmpty(x.line_items))
        .map((x) => x.line_items)) {
        const [priority] = line_items.map((x) => x.device_ids).includes(device_id)
          ? _partition(line_items, (i) => i.device_ids.includes(device_id))
          : _partition(line_items, (i) => !i.is_collapsed);

        if (!_isEmpty(priority)) {
          count++;
        }
      }
      setCount(count);

      const past_orders = orders
        .filter((x) => x.completed_at)
        .filter((x) => moment(x.completed_at).isAfter(moment().subtract(1, "hours")));
      setChart({
        datasets: [
          {
            label: "avg/min",
            data: past_orders.map((x) => moment.duration(x.average_time).minutes()),
            fill: false,
          },
        ],
        labels: past_orders.map((x) => moment(x.completed_at).format("LT")),
      });
    }
  }, [orders, device_id]);

  return (
    <div className={global.root}>
      <Helmet>
        <title>{`(${count}) Orders`}</title>
      </Helmet>
      <div className={global.topBg}></div>
      <div className={global.container}>
        <PageHeader title="Orders" icon={<ShoppingBasketIcon fontSize="large" />}>
          <div className={global.grow} />
          <ChartTile title={"Open"} count={count} chart={chart} />
        </PageHeader>
        <OrdersList
          orders={orders.filter((x) => x.completed_at == null)}
          onRefresh={onRefresh}
          onDone={onDone}
          device_id={device_id}
        />
      </div>
    </div>
  );
};

Orders.propTypes = {
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      to_go: PropTypes.bool,
      created_at: PropTypes.string,
      line_items: PropTypes.arrayOf(PropTypes.object),
    })
  ).isRequired,
  onRefresh: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default Orders;
